module.exports = __webpack_public_path__ + "bc43a5316f559939e3da052fe94a009c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/BebasNeue-Regular.woff
// module id = 367
// module chunks = 1